import { RouteObject } from 'react-router-dom';

import { SAUNA_ROUTES } from './sauna.constants';

export const saunaRoutes = [
  {
    path: SAUNA_ROUTES.SAUNA_PAGE,
    lazy: async () => ({
      Component: (await import('./SaunaPage')).SaunaPage,
    }),
  },
  {
    path: SAUNA_ROUTES.SAUNA_RESERVATION_EDIT_CALENDAR,
    lazy: async () => ({
      Component: (await import('./EditReservation/EditReservationCalendarPage'))
        .EditReservationCalendarPage,
    }),
  },
  {
    path: SAUNA_ROUTES.SAUNA_RESERVATION_EDIT_CONFIRM,

    lazy: async () => ({
      Component: (
        await import('./EditReservation/EditReservationConfirmationPage')
      ).EditReservationConfirmationPage,
    }),
  },
  {
    path: SAUNA_ROUTES.SAUNA_RESERVATION_CALENDAR,
    lazy: async () => ({
      Component: (await import('./NewReservation/ReservationCalendarPage'))
        .ReservationCalendarPage,
    }),
  },
  {
    path: SAUNA_ROUTES.SAUNA_RESERVATION_CONFIRM,
    lazy: async () => ({
      Component: (await import('./NewReservation/ReservationConfirmationPage'))
        .ReservationConfirmationPage,
    }),
  },
] satisfies RouteObject[];
